module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tipsTitle":"回购注意事项"}}')
  delete Component.options._Ctor
}
